import './modal.less';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

class ModalPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: true,
            offsetX: 0,
            offsetY: 0,
            dragging: false
        };
        this.oldOffsetX = 0;
        this.oldOffsetY = 0;
        this.startX = 0;
        this.startY = 0;

        this.clk = this.clk.bind(this);
        this.hide = this.hide.bind(this);
        this.close = this.close.bind(this);
        this.stopBubble = this.stopBubble.bind(this);
        this.onRef = this.onRef.bind(this);
        this.dragStart = this.dragStart.bind(this);
        this.dragMove = this.dragMove.bind(this);
        this.dragEnd = this.dragEnd.bind(this);
    }

    clk(e) {
        e.preventDefault();
        const { onDone } = this.props;
        this.hide(e);
        onDone && onDone(e);
    }

    stopBubble(e) {
        e.preventDefault();
        e.stopPropagation();
    }

    hide(e) {
        e && e.preventDefault();
        this.setState({
            show: false
        });
        setTimeout(() => {
            this.teardown();
        }, 100);
    }

    close(e) {
        this.hide(e);
        const { onCancel } = this.props;
        onCancel && onCancel(e);
    }

    teardown() {
        const { container } = this.props;
        ReactDOM.unmountComponentAtNode(container);
        container.parentNode.removeChild(container);
    }

    onRef(ref) {
        this.modal = ref;

        // 组件被移除时会再次调用 onRef，但传入的是 null
        if (!ref) {
            return;
        }

        const [w, h] = [ref.offsetWidth, ref.offsetHeight];
        const offsetX = Math.ceil((window.innerWidth - w) / 2);
        const offsetY = Math.ceil((window.innerHeight - h) / 2);
        this.setState({
            offsetX: offsetX > 0 ? offsetX : 0,
            offsetY: offsetY > 0 ? offsetY : 0
        });
    }

    dragStart(event) {
        this.stopBubble(event);

        this.startX = event.clientX;
        this.startY = event.clientY;
        this.oldOffsetX = this.state.offsetX;
        this.oldOffsetY = this.state.offsetY;
        this.setState({
            dragging: true
        });
    }

    dragMove(event) {
        this.stopBubble(event);

        if (this.state.dragging) {
            const x = event.clientX;
            const y = event.clientY;
            this.setState({
                offsetX: this.oldOffsetX + (x - this.startX),
                offsetY: this.oldOffsetY + (y - this.startY)
            });
        }
    }

    dragEnd(event) {
        this.stopBubble(event);

        if (this.state.dragging) {
            this.startX = 0;
            this.startY = 0;
            this.oldOffsetX = 0;
            this.oldOffsetY = 0;
            this.setState({
                dragging: false
            });
        }
    }

    render() {
        const {
            title, content, hideDone, doneLabel, cancelLabel, layerClass, lyctClass, width, height
        } = this.props;
        const { show, offsetX, offsetY } = this.state;
        let doneNode, cancelNode, btnsNode;

        // 没有 autoprefixer，需要对不同浏览器做兼容
        const transformStyle = {};
        const innerStyle = {};
        ['WebkitTransform', 'MozTransform', 'OTransform', 'msTransform', 'transform'].forEach((elem) => {
            transformStyle[elem] = `translate(${offsetX}px, ${offsetY}px)`;
        });
        if (width) {
            transformStyle.width = `${width}px`;
        }
        if (height) {
            transformStyle.height = `${height}px`;
            innerStyle.height = `${height - 59}px`;
        }
        if (!hideDone) {
            doneNode = (
                <a href="#" onClick={this.clk} className="btn u-nbtn u-nbtn-blue"><i>{doneLabel}</i></a>
            );
        }
        if (cancelLabel) {
            cancelNode = (
                <a href="#" onClick={this.close} className="btn u-nbtn n-nbtn-white"><i>{cancelLabel}</i></a>
            );
        }
        if (doneNode || cancelNode) {
            btnsNode = (
                <div className="lybtn">
                    {doneNode}
                    {cancelNode}
                </div>
            );
        }
        return show ? (
            <div className="m-layer_mask" onMouseMove={this.state.dragging ? this.dragMove : null}>
                <div className={layerClass} style={transformStyle} ref={this.onRef}>
                    <div className="zbar" onMouseDown={this.dragStart} onMouseUp={this.dragEnd}>
                        <div className="zttl">{title}</div>
                    </div>
                    <div className="zcnt" style={innerStyle}>
                        <div className={lyctClass}>
                            {typeof content === 'function' ? content() : content}
                            {btnsNode}
                        </div>
                    </div>
                    <span className="zcls" title="关闭窗体" onClick={this.hide}>×</span>
                </div>
            </div>
        ) : null;
    }
}
ModalPopup.propTypes = {
    title: PropTypes.string,
    hideDone: PropTypes.bool,
    doneLabel: PropTypes.string,
    content: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.element]),
    onDone: PropTypes.func,
    cancelLabel: PropTypes.string,
    onCancel: PropTypes.func,
    layerClass: PropTypes.string,
    lyctClass: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number
};
ModalPopup.defaultProps = {
    title: '系统提示',
    doneLabel: '确认',
    layerClass: 'm-layer m-layer-w2',
    lyctClass: 'lyct f-cb f-tc f-fs1'
};
export default function Modal(option = {}) {
    const tempDiv = document.createElement('div');
    document.body.appendChild(tempDiv);
    const props = {
        ...option,
        container: tempDiv
    };
    return ReactDOM.render(<ModalPopup {...props} />, tempDiv);
}



// WEBPACK FOOTER //
// ./client/component/message/modal.js